// const BASE_URL = "http://v2.com";
const BASE_URL = "https://api.v2.taizhicn.com";
// 检测邮箱格式
const checkEmail = function(str){
  if(str.length === 0){
    return {
      code:'2001',
      msg:'邮箱不能为空',
      success:false
    };
  }
  const reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
  if(!reg.test(str)){
    return {
      code:'2002',
      msg:'邮箱格式不正确',
      success:false
    };
  }
  return {
    code:'200',
    msg:'邮箱验证成功',
    success:true
  };
}

// 检测密码格式
const checkPassword = function(str){
  if(str.length === 0){
    return {
      code:'2001',
      msg:'密码不能为空',
      success:false
    };
  }
  const reg = /^(\w){6,30}$/;
  if(!reg.test(str)){
    return {
      code:'2002',
      msg:'只能输入6-30个字母、数字、下划线',
      success:false
    };
  }
  return {
    code:'200',
    msg:'密码验证成功',
    success:true
  };
}

//检测邀请码格式
const checkNum = function(num){   
  var reg = /^[1-9]\d*$/;
  if(!reg.test(num)){
    return {
      code:'2002',
      msg:'请输入正确的邀请码，没有可不填',
      success:false
    };
  }
  return {
    code:'200',
    msg:'邀请码格式正常',
    success:true
  };
}
export default {
  checkEmail,
  checkPassword,
  checkNum,
  BASE_URL
}